<template>
  <div>
    <b-container class="py-3">
      <b-row>
        <b-col>

          <page-title :title="pageTitle" />

          <b-alert v-if="client && client.isOffline" show variant="info">
            This client is currently available offline.
          </b-alert>

          <div v-if="client && !client.isOffline && isCheckoutSupported === null">
            <b-alert show class="mb-3" variant="info">
              Checking to see if offline access is supported...
            </b-alert>            
          </div>

          <div v-if="client && !client.isOffline && isCheckoutSupported === false">
            <b-alert show class="mb-3" variant="warning">
              Sorry, offline access is not supported on your web browser. Try refreshing this page.
            </b-alert>            
          </div>

          <div v-if="client && !client.isOffline && isCheckoutSupported">
            <p>Do you want to check out {{ client.applicationUser.displayName }} for offline access?</p>
            <p>Use Check Out while connected to the internet to prepare this client's questionnaire for offline use on this device.
              Select Save or Next to save answers on the device before leaving each page. When you are back online, use Check In on this device
              to synchronize saved answers before completing the questionnaire or downloading a report.
            </p>
            <b-button @click="checkOut" v-if="!client.isOffline" variant="primary">
              Check Out for Offline Use
            </b-button>
          </div>

        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import marked from 'marked';
import AuthMixin from '../../Mixins/AuthMixin.vue'

export default {
  name: "SubscriberClientCheckOut",
  props: ['id'],
  mixins: [AuthMixin],
  data() {
    return {
      client: null,
      isCheckoutSupported: null
    }
  },
  computed: {
    pageTitle: function () {
      if (!this.client)
        return 'Loading...';
      
      return 'Check Out ' + this.client.applicationUser.firstName + ' ' + this.client.applicationUser.lastName + ' For Offline Access';
    },
  },
  methods: {
    getIsCheckoutSupported: function () {
      navigator.serviceWorker.controller.postMessage({
        action: 'getIsCheckoutSupported'
      });
    },
    checkOut: function () {
      navigator.serviceWorker.controller.postMessage({
        action: 'checkOut',
        clientId: this.client.id,
        authToken: this.getAuthToken()
      });
    },
    load: function () {
      axios
        .get('/api/client/' + this.id + '?includes=applicationUser')
        .then(response => {
          this.client = response.data;
        })
        .catch(error => {
          console.log(error);
        });

        setTimeout(() => {
          if (!this.isCheckoutSupported)
            this.isCheckoutSupported = false;
        }, 2000);

        this.getIsCheckoutSupported();
    }
  },
  watch: {
  },
  created() {
  },
  async mounted () {
    this.load();

    navigator.serviceWorker.onmessage = msg => {
      if (msg.data.action == 'checkedOut') {
        this.load();

        this.$parent.showToast('That client is now checked out for offline access.', {
          title: 'Client Checked Out',
          variant: 'success',
          autoHideDelay: 5000
        });

        this.$router.push('/');
      }

      if (msg.data.action == 'gotIsCheckoutSupported') {
        this.isCheckoutSupported = true;
      }

    }
  }
};
</script>